import { ConnectionField } from "../../../ConnectionField";
import { ComboBox, IComboBoxProps } from "office-ui-fabric-react";
import { FieldValue } from "../../../ConnectionFieldValue";

type Props = {
    isLinked: boolean;
    fieldLabel: string | JSX.Element;
    value: string | undefined;
    isLoading: boolean;
}

const PlanGroupSelection = (props: Props & IComboBoxProps) => {
    const { isLinked, fieldLabel, value, isLoading } = props;
    return <ConnectionField
        label={fieldLabel}
        isLinked={isLinked}
        isLoading={isLoading}
        editor={<ComboBox {...props}
            useComboBoxAsMenuWidth={props.useComboBoxAsMenuWidth ?? true}
            allowFreeform={props.allowFreeform ?? true}
        />}
        viewer={<FieldValue value={value} />}
    />
}

export default PlanGroupSelection;